var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlaylist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-711.000000, -194.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(712.000000, 195.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#333333",
    x: 0,
    y: 0,
    width: 24,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(5.000000, 5.000000)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 1,
    width: 8,
    height: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 7.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7,
    width: 8,
    height: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 13.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 13,
    width: 8,
    height: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 19.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 19,
    width: 8,
    height: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlaylist);
export default __webpack_public_path__ + "static/media/icon-playlist.7a6f5447eba4ffbe89875c4e998b58f9.svg";
export { ForwardRef as ReactComponent };